<div class="flex justify-between">
	<div class="w-[50%] mr-[16px]">
		<lbca-date-picker-condensed
			[label]="labelDateValue"
			(changeValue)="changeDate($event)"
			[value]="valueInput"
			[labeled]="isLabeled"
			[editable]="isEditable"
			[tabeled]="isTabeled"
			[disabled]="isDisabled"
			[require]="isRequired"
			[rules]="rules"
			[error]="errorDate"
			[helperText]="helperTextValue"
			(validStatus)="setValid($event)"
			(focusState)="setFocus($event)"
		></lbca-date-picker-condensed>
	</div>

	<div class="w-[50%] ml-[16px]">
		<lbca-timepicker-condensed
			[label]="labelTimeValue"
			(changeValue)="changeTime($event)"
			(setError)="setErrorFn($event)"
			[value]="formatToTimePiker(valueInput)"
			[require]="isRequired"
			[helperText]="helperTextValue"
			[labeled]="isLabeled"
			[editable]="isEditable"
			[tabeled]="isTabeled"
			[disabled]="isDisabled"
			[error]="errorTime"
			(focusState)="setFocus($event)"
			(validStatus)="setValid($event)"
		></lbca-timepicker-condensed>
	</div>
</div>
